import $ from 'jquery';

export default class NavBar {
    #$header;
    #$nav;
    #$hamburger;
    #$arrow;
    #$search;
    #$menuItem;
    #$submenus;
    #$submenuItem;
    #$descriptions;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        this.#$header = $(".site_header");
        this.#$nav = this.#$header.find(".sitenav");
        this.#$hamburger = this.#$header.find('.site_header__hamburger');
        this.#$arrow = this.#$header.find('.site_header__arrow');
        this.#$search = this.#$header.find('.site_header__search .search-button');
        this.#$menuItem = this.#$header.find('.sitenav__menu_item');
        this.#$submenus = this.#$header.find('.sitenav__subnav');
        this.#$submenuItem = this.#$header.find('.sitenav__submenu_item');
        this.#$descriptions = this.#$header.find('.sitenav__descriptions');
    }

    events() {
        const me = this;

        this.#$nav.on('mouseleave', function() {
            me.closeMenu();
        });

        //Header Open/Close
        this.#$hamburger.on('click', function(){
            me.#$header.addClass('js-open');
        });

        this.#$arrow.on('click', function(){
            me.closeMenu();
        });

        //Search Bar open/close
        this.#$search.on('click', function(){
            me.#$header.toggleClass('search-open');
            $(this).parent().toggleClass('open');
        });

        this.#$menuItem.on('mouseover', function() {
            me.#$menuItem.removeClass("js-open");
            me.#$nav.removeClass("js-no-desc");
            me.#$descriptions.find(".sitenav__submenu_description").removeClass("js-open");

            if($(this).is(".sitenav__menu_item--has-submenu")) {
                const index = $(this).attr("data-index");
                const $desc = me.#$descriptions.find('.sitenav__submenu_description[data-index="'+index+'"]');

                $(this).addClass("js-open");
                me.#$submenus.find(".sitenav__submenu").removeClass("js-open");
                me.#$submenus.find('.sitenav__submenu[data-index="'+index+'"]').addClass("js-open");
                me.#$header.addClass("js-submenu-open");

                if($desc.length == 0) {
                    me.#$nav.addClass("js-no-desc");
                }
            } else {
                me.#$submenus.find(".sitenav__submenu").removeClass("js-open");
                me.#$header.removeClass("js-submenu-open");
            }
        });

        this.#$submenuItem.on('mouseover', function() {
            const index = $(this).parent().attr("data-index");
            const subindex = $(this).attr("data-subindex");
            const $desc = me.#$descriptions.find('.sitenav__submenu_description[data-index="'+index+'"][data-subindex="'+subindex+'"]');

            me.#$descriptions.find(".sitenav__submenu_description").removeClass("js-open");

            $desc.addClass("js-open");
        });

        this.#$menuItem.on('mouseleave', function() {

        });
    }

    closeMenu() {
        this.#$header.removeClass('js-open')
            .removeClass('js-search-open')
            .removeClass("js-submenu-open");

        this.#$nav.removeClass("js-no-desc");
        this.#$menuItem.removeClass("js-open");
        this.#$submenus.find(".sitenav__submenu").removeClass("js-open");
        this.#$descriptions.find(".sitenav__submenu_description").removeClass("js-open");
        this.#$search.parent().removeClass('js-open');
    }
}